import { TAX_PER_CONFIG_ITEM } from './tax-per-config.js'
import { TAX_PER_EXCLUSIONS_ITEM } from './tax-per-exclusions.js'
import { TAX_PER_APPLIED_ITEM } from './tax-per-applied.js'

/** @type {import('../help-index.js').HelpScreen} */
export const TAX_PER_HELP = {
  screenId: 'tax-per',
  label: 'Agente de Percepción',
  navPath: 'Impuestos → Agente de Percepción',
  keywords: [
    'agente de percepción', 'percepción', 'iibb', 'exclusión', 'mínimo imponible',
    'factura venta', 'cliente exento',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Configurá qué impuestos percibís al facturar, exclusiones por cliente y consultá las percepciones aplicadas.',
  sidebarItems: [
    TAX_PER_CONFIG_ITEM,
    TAX_PER_EXCLUSIONS_ITEM,
    TAX_PER_APPLIED_ITEM,
  ],
}
